/**
 * Calculates the number of columns per row based on screen width
 * This matches the breakpoints defined in SearchResultsPanel.module.css
 * 
 * @param {number} width - Screen width in pixels
 * @returns {number} Number of columns per row
 */
export const getColumnsPerRow = (width) => {
  if (width < 550) {
    // Mobile: 2 columns
    return 2;
  } else if (width < 1024) {
    // Medium screens: auto-fill with minmax(220px-250px)
    // Estimate based on typical screen sizes: ~3-4 columns
    // We'll use 3 as a safe default for this range
    return 3;
  } else if (width < 1920) {
    // Large screens: 5 columns
    return 5;
  } else {
    // Very large screens: 6 columns
    return 6;
  }
};

/**
 * Calculates the optimal perPage value to be a multiple of columns per row
 * 
 * @param {number} width - Screen width in pixels
 * @param {number} rowsPerPage - Number of rows to show per page (default: 4)
 * @returns {number} Optimal perPage value
 */
export const getOptimalPerPage = (width, rowsPerPage = 4) => {
  const columns = getColumnsPerRow(width);
  return columns * rowsPerPage;
};

